import { render, staticRenderFns } from "./CartContent_deprecated.vue?vue&type=template&id=fd225c10&scoped=true&"
import script from "./CartContent_deprecated.vue?vue&type=script&lang=js&"
export * from "./CartContent_deprecated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd225c10",
  null
  
)

export default component.exports